<div class="h-layout v-layout" *transloco="let t">
  <img class="order-5 mx-auto md:order-6" ngSrc="assets/images/buildigo-sorry.png" width="600" height="450" />
  <h1 class="text-center">{{ t('article.unavailable.text') }}</h1>
  <div class="mt-6 flex justify-center">
    @for (item of availableLanguages$ | async; track item) {
      <a class="btn btn-elevated btn-primary mx-2" [href]="item.path" bgoOpenNewTab>
        {{ t('article.unavailable.readIn', {language: item.lang | uppercase}) }}
      </a>
    }
    <a class="btn btn-elevated btn-primary mx-2" [routerLink]="linkService.previousPage || linkService.homePath">
      {{ t('article.unavailable.back') }}
    </a>
  </div>
</div>
